import css from 'styled-jsx/css';

export default css`
  .Post__recipeRoundupNav--sticky .Post__recipeRoundupNav--container {
    position: fixed;
    top: 0;
    width: 100vw;
    left: 0;
    z-index: 101;
    overflow-y: hidden;
  }

  .Post__recipeRoundupNav--sticky::before {
    display: block;
    height: 150px; /* hack to make it so we can jump to anchors when the nav is fixed */
  }

  .Post__recipeRoundupNav--sticky .subsectionList {
    scroll-snap-type: x mandatory;
    display: flex;
    -webkit-overflow-scrolling: touch;
    overflow-x: scroll;
  }
  .Post__recipeRoundupNav--sticky .subsectionList li {
    border-right: 1px solid white;
    min-width: 100vw;
    height: 100vh;
    scroll-snap-align: start;
    text-align: center;
    position: relative;
    height: inherit;
  }

  .Post__recipeRoundupNav--yellowButtons a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .Post__recipeRoundupNav--sticky a {
    padding: 1rem;
  }

  @media (min-width: 64rem) {
    .Post__recipeRoundupNav--sticky::before {
      height: 90px;
    }
    .Post__recipeRoundupNav--sticky .Post__recipeRoundupNav--container {
      position: fixed;
      top: 0;
      width: 100vw;
      left: 0;
      z-index: 101;
    }

    .subsectionList {
      display: flex;

      scroll-snap-type: inherit;
      -webkit-overflow-scrolling: inherit;
      overflow-x: inherit;
      justify-content: space-between;
    }

    .subsectionList li {
      min-width: inherit;
      height: inherit;
      scroll-snap-align: inherit;
      text-align: inherit;
      position: static;
    }

    .Post__recipeRoundupNav--sticky .subsectionList li {
      flex: 0 0 20%;
      flex-grow: 1;

      min-width: inherit;
      height: inherit;
      scroll-snap-align: inherit;
      text-align: inherit;
      position: static;
    }

    .Post__recipeRoundupNav--yellowButtons a {
      text-align: center;
    }
  }
`;
